export { SplitView, type SplitViewProps } from './split-view';
export * from './elements';
export type { SplitHostProps } from 'react-native-screens/experimental';
